import { createContext } from 'react'

import { initialContext } from './constants'

const AppContext = createContext({
  ...initialContext,
  updateContext: () => {},
})

export default AppContext
